import React, { createContext, useContext, useEffect, useState } from 'react';

const CookieContext = createContext();

export const useCookieContext = () => useContext(CookieContext);

export const CookieProvider = ({ children }) => {
  const [isCookieModalVisible, setIsCookieModalVisible] = useState(true);
  const [isPreferencesModalVisible, setIsPreferencesModalVisible] = useState(false);
  const [isCookieIcon, setIsCookieIcon] = useState(false);
  const [isCookieActive, setIsCookieActive] = useState(false);

  const openPreferencesModal = () => setIsPreferencesModalVisible(true);
  const closePreferencesModal = () => setIsPreferencesModalVisible(false);

  const contextValue = {
    isPreferencesModalVisible,
    openPreferencesModal,
    closePreferencesModal,
    isCookieIcon,
    setIsCookieIcon,
    isCookieModalVisible,
    setIsCookieModalVisible,
    isCookieActive,
    setIsCookieActive
  }

  return (
    <CookieContext.Provider value={contextValue}>
      {children}
    </CookieContext.Provider>
  );
};
